import { useCallback, useEffect, useState } from 'react';
const STORAGE_KEY = 'leits-theme';
function readTheme() {
    const attr = document.documentElement.getAttribute('data-theme');
    if (attr === 'dark' || attr === 'light')
        return attr;
    return 'light';
}
/** 主题切换：写 data-theme 并记忆（Demo 阶段用 localStorage，正式版改为服务端偏好）。 */
export function useTheme() {
    const [theme, setTheme] = useState(readTheme);
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        }
        catch {
            // 忽略隐私模式下的写入失败
        }
    }, [theme]);
    const toggle = useCallback(() => {
        setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
    }, []);
    return { theme, toggle };
}
//# sourceMappingURL=theme.js.map